import {useEffect, useRef, useState} from 'react'
import {UserDialogWrapper} from './components/UserDialogWrapper'
import {useParams} from 'react-router'
import {dialogApi} from '../../api/dialogApi'
import {AWS_FILE_URL} from '../../constants/apiConstants'
import {
  disconnectConversationSocket,
  initiateConversationSocketConnection,
} from '../../api/Sockets/conversation.socket.service'
import NotFoundImg from '../../assets/Icons/NotFound.svg?url'
import {ShowToasterMessage} from '../../components/ShowToasterMessage/ShowToasterMessage'
import styles from './components/UserDialogWrapper.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../Translation/English/dialog'

export const UserDialog = (): React.ReactElement => {
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: details, isError} = dialogApi.useDialogDetails(dialogId ?? '')
  const wt = useWt()
  const [showWrapper, setShowWrapper] = useState<boolean>(false)
  const [isConvoArchived, setIsConvoArchived] = useState<boolean>(false)
  const [coverImage, setCoverImage] = useState<string | undefined>(undefined)

  const hasInitialized = useRef<boolean>(false)

  useEffect(() => {
    if (details?.id && !hasInitialized.current) {
      setIsConvoArchived(!!details.isAchived)
      setShowWrapper(true)
      setCoverImage(details.coverImage || 'file-1741086297591.png')
      hasInitialized.current = true
    }
  }, [details])

  const handleBeforeUnload = (): void => disconnectConversationSocket()

  useEffect(() => {
    initiateConversationSocketConnection(dialogId)
    window.addEventListener('beforeunload', handleBeforeUnload)
    return (): void => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      disconnectConversationSocket()
    }
  }, [dialogId])

  const renderNotFound = (): React.ReactElement => (
    <div className={styles.notFound}>
      <img src={NotFoundImg} alt="not-found" />
      <div className={styles.notFoundTitle}>{wt(DIALOG.dialogNotFound)}</div>
    </div>
  )

  return (
    <>
      <ShowToasterMessage />
      {isError
        ? renderNotFound()
        : showWrapper && (
            <div className={styles.userDialog}>
              <div className={styles.bgImg}>
                <img
                  src={`${AWS_FILE_URL}/${coverImage}`}
                  alt="coverImage"
                  width="100%"
                  height="100%"
                  className={styles.coverImg}
                />
                {details?.logoImage && (
                  <img
                    src={`${AWS_FILE_URL}/${details.logoImage}`}
                    alt="logo"
                    className={styles.logoImg}
                  />
                )}
              </div>
              <div className={styles.wrapper}>
                {isConvoArchived ? (
                  <>
                    <div className={styles.archived}>
                      <div className={styles.archiveTitle}>
                        {wt(DIALOG.archivedDialogTitle)}
                      </div>
                      <div className={styles.archiveMessage}>
                        {wt(DIALOG.archivedDialogMessage)}
                      </div>
                    </div>
                  </>
                ) : (
                  <UserDialogWrapper />
                )}
              </div>
            </div>
          )}
    </>
  )
}
